import React from 'react';
import { TrendingUp, CheckCircle, Users, Target, LineChart } from 'lucide-react';

const features = [
  'Registro manual dos vencedores de editais monitorados fora do sistema',
  'Comparação entre preços praticados pelos concorrentes e os valores ofertados pela empresa',
  'Identificação de padrões de concorrência por segmento, região e modalidade',
  'Avaliação da competitividade da empresa no mercado ao longo do tempo',
  'Mapeamento de concorrentes recorrentes por tipo de licitação',
  'Relatórios de inteligência competitiva para subsidiar estratégias de precificação',
];

const ConcorrentesResultados: React.FC = () => {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center p-6 md:p-10">
      <div className="max-w-xl w-full text-center">

        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand-50 dark:bg-[rgba(203,106,30,0.15)] text-brand-700 dark:text-brand-300 text-xs font-semibold uppercase tracking-widest mb-6">
          Em desenvolvimento
        </span>

        <div className="w-16 h-16 bg-brand-50 dark:bg-[rgba(203,106,30,0.15)] rounded-2xl flex items-center justify-center mx-auto mb-5">
          <TrendingUp className="w-8 h-8 text-brand-700 dark:text-brand-300" />
        </div>

        <h1 className="text-2xl font-bold text-ink-title dark:text-ink-title-dark mb-3">Resultados dos Concorrentes</h1>

        <p className="text-ink-subtitle dark:text-ink-subtitle-dark mb-8 leading-relaxed">
          Painel de inteligência competitiva para acompanhar o desfecho das disputas no mercado
          e comparar o desempenho da empresa frente aos concorrentes monitorados.
        </p>

        <div className="bg-surface dark:bg-surface-dark border border-line dark:border-line-dark rounded-xl p-6 text-left space-y-3 mb-6">
          <h3 className="text-sm font-semibold text-ink-label dark:text-ink-label-dark mb-4">O que estará disponível:</h3>
          {features.map((item, i) => (
            <div key={i} className="flex items-start gap-2.5">
              <CheckCircle className="w-4 h-4 text-brand-700 dark:text-brand-300 flex-shrink-0 mt-0.5" />
              <span className="text-sm text-ink-text dark:text-ink-text-dark leading-relaxed">{item}</span>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-3 gap-3">
          {[
            { icon: <Users className="w-5 h-5 text-brand-700 dark:text-brand-300" />, label: 'Concorrentes' },
            { icon: <Target className="w-5 h-5 text-brand-700 dark:text-brand-300" />, label: 'Competitividade' },
            { icon: <LineChart className="w-5 h-5 text-brand-700 dark:text-brand-300" />, label: 'Tendências' },
          ].map((card, i) => (
            <div key={i} className="bg-surface-alt dark:bg-surface-dark-alt border border-line dark:border-line-dark rounded-lg p-3 flex flex-col items-center gap-1.5">
              {card.icon}
              <span className="text-xs text-ink-subtitle dark:text-ink-subtitle-dark font-medium">{card.label}</span>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default ConcorrentesResultados;
